import './BetslipUserAliasDialog.less';

import React, { useEffect, useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { DialogBody, Docked } from '@/ui/dialogs/Dialog';
import i18n from '@i18n';
import { clearSubmit } from '@/betslip/commands';
import ArrowDownIcon from '@/icons/ArrowDownIcon';
import Positive from '@/icons/Positive';
import { TICKET_DETAIL_ALIAS } from '@/routing/routes';
import { navigate } from '@/routing';
import { Button } from 'nike-ui/src/components/button/Button';

import { accountUserData$ } from '@/account/subs';
import { savedTicketParams$ } from '@/mytickets/saved/subs';

function BetslipUserAliasDialog() {
    const [alias, setAlias] = useState('');
    const [newAlias, setNewAlias] = useState('');
    const [sending, setSending] = useState(false);
    const derefSub = useReframe();
    const savedBetslipParams = derefSub(['betslip/savedBetslipParams']);
    const ticketusSavedParams = derefSub(savedTicketParams$);
    const userData = derefSub(accountUserData$);
    const error = derefSub(['ticketus/aliasError']);
    const isAliasSaved = derefSub(['ticketus/isAliasSaved']);

    function validateAlias(e) {
        const pattern = /[^A-Za-z0-9]+/;
        if (!pattern.test(e.target.value)) {
            setAlias(e.target.value);
        }
    }
    function setTicketAlias() {
        setNewAlias(alias);
        setSending(true);
        dispatch([
            'ticketus/setTicketAlias',
            {
                ticketId: savedBetslipParams.get('ticketNumber'),
                alias: `${userData.get('nickname')}-${alias}`,
                forceUseOnNewTicket: error === 'ExistingUserAlias' && alias === newAlias
            }
        ]);
    }
    function goToTicketDetail() {
        onClose();
        navigate(TICKET_DETAIL_ALIAS, { alias: `${userData.get('nickname')}-${alias}` });
    }

    function onClose() {
        dispatch(clearSubmit());
        // next line re-renders popup earlier then previous line can close the popup
        // reframe.dispatch(['ticketus/cleanTicketAliasError']);
        // so let's clean up in effect
    }

    useEffect(() => () => dispatch(['ticketus/cleanTicketAliasError']), []);

    if (!savedBetslipParams && !ticketusSavedParams) {
        return null;
    }
    return (
        <Docked onClose={onClose} className="match-options-dialog">
            <DialogBody>
                <div className="betslip-user-alias-dialog">
                    <Positive width={70} height={70} />
                    {!isAliasSaved || error ? (
                        <>
                            <div>{i18n('ticketus.alias.dialog.doneText')}</div>
                            <div className="ticket-number">{savedBetslipParams.get('betslipNumber')}</div>

                            <ArrowDownIcon fill={'#f4f6f9'} width={54} height={20} />
                            <div className="name-ticket-text">{i18n('ticketus.alias.dialog.nameTicket')}</div>
                            <div className="user-alias-input">
                                <div className="user-nickname">{userData.get('nickname')}</div>
                                <div className="alias-separator">-</div>
                                <div className="alias-input-wrap">
                                    <div className={`alias-input ${error ? 'alias-error-input' : ''}`}>
                                        <input
                                            data-atid="user-alias-input"
                                            maxLength="10"
                                            onChange={e => validateAlias(e)}
                                            autoFocus
                                            value={alias}
                                            placeholder={i18n('ticketus.alias.dialog.ticketName')}
                                            className={`${error ? 'alias-error-input' : ''}`}
                                        />
                                    </div>
                                    <div className="alias-error">
                                        {error ? i18n(`ticketus.alias.dialog.${error}`) : null}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="ticket-alias-saved">
                            {i18n('ticketus.alias.dialog.ticketName')}
                            <span className="ticket-alias">
                                {userData.get('nickname')}-{alias}
                            </span>
                            {i18n('ticketus.alias.dialog.aliasSaved')}
                        </div>
                    )}

                    <div className="betslip-user-alias-dialog-buttons">
                        <Button className="red" onClick={onClose} label={i18n('help.link.close')} />
                        {!isAliasSaved || error ? (
                            <Button
                                data-atid="user-alias-button-set"
                                onClick={setTicketAlias}
                                disabled={alias.length < 1 || (sending && !error)}
                                label={i18n(
                                    error === 'ExistingUserAlias' && alias === newAlias
                                        ? 'jsp.tiket.pouzitVolnyTiket'
                                        : 'ticketus.alias.dialog.addName'
                                )}
                            />
                        ) : (
                            <Button
                                data-atid="user-alias-button-open"
                                onClick={goToTicketDetail}
                                label={i18n('ticketus.alias.dialog.showTicket')}
                            />
                        )}
                    </div>
                </div>
            </DialogBody>
        </Docked>
    );
}

export default BetslipUserAliasDialog;
